/** --------------------------------------------------
*
*   components
*   CART
*
*  -------------------------------------------------- */

(function($) {

  "use strict";

  $(document).ready(function() {

    // move breadcrumbs:
    // -> @todo: this should be somewhere else (?)
    $('nav.breadcrumb').appendTo('#main-content');

    // detect number change:
    // page will refresh after a number change, so display
    // a "loader" when processing
    $('body.path-cart').on('change', '.form-number', function() {
      $('body').addClass('js-page-busy');
    });
  });

  Drupal.behaviors.couponCodeAjax = {
    attach: function (context, settings) {

      if($('body').hasClass('path-cart')) {

        // wrap the coupon form in a container:
        const $couponForm = $(document).find('div[data-drupal-selector="edit-coupon-redemption"]');
        if($couponForm.length > 0) {
          const $couponParent = $couponForm.parent('#coupon_form-ajax-wrapper');
          if($couponParent.length === 0) {
            const $couponFormWrapper = $('<div id="coupon_form-ajax-wrapper"></div>');
            $couponForm.wrap($couponFormWrapper);
          }
        }

        // move the "total" block:
        const $cart_total = $(document).find('#cart-total-wrapper');
        const $coupons = $(document).find('#coupon_form-ajax-wrapper');
        if($cart_total.length > 0 && $coupons.length > 0) {
          $cart_total.insertAfter($coupons);
        }
      }
    }
  };
})(jQuery);
